/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";

/** Utilities */
import AddRenewal from "./features/AddContractRenewal";
import NewContract from "./features/NewContract";
import CreateRenewal from "./features/CreateContractRenewal";
import { useAddContractRenewalScopeMutation, useDeleteContractRenewalScopeMutation, useExtractCoveredMutation, useGetContractRenewalAvailableScopesMutation, useGetContractRenewalScopesMutation, useImportCoveredMutation } from "../../../../../../app/services/contractAPI";
import { ContractContext } from "../../../../../../utils/context/ContractContext";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import ToastService from "../../../../../../services/toastService/ToastService";
import UpdateRenewal from "./features/UpdateRenewalScope";
import { saveAs } from 'file-saver';
import ImportContractRenewal from "./features/ImportContractRenewal";

const Renewal = () => {
  const formRef = React.useRef();
  const { contractData, contractId } = useContext(ContractContext);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);
  const [contractRenewalScopes, setContractRenewalScopes] = useState([]);
  const [contractRenewalAvailableScopes, setContractRenewalAvailableScopes] = useState([]);

  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isContractModelOpen, setIsContractModelOpen] = useState(false);
  const [isNewScopeModel, setIsNewScopeModel] = useState(false);
  const [isCreateRenewalModelOpen, setIsCreateRenewalModelOpen] = useState(false);

  const [isUpdateRenewalModelOpen, setIsUpdateRenewalModelOpen] = useState(false);
  const [selectedEditRow, setSelectedEditRow] = useState(null);

  const [isImportModelOpen, setIsImportModelOpen] = useState(false);

  const { confirm } = SwalAlert()

  const [getAllContractRenewalScopes, {
    isFetching: isAllContractRenewalScopesFetching,
    isSuccess: isAllContractRenewalScopesFetched,
    data: AllContractRenewalScopesData,
  }] = useGetContractRenewalScopesMutation();

  const [getAllContractRenewalAvailableScopes, {
    isFetching: isAllContractRenewalAvailableScopesFetching,
    isSuccess: isAllContractRenewalAvailableScopesFetched,
    data: AllContractRenewalAvailableScopesData,
  }] = useGetContractRenewalAvailableScopesMutation();

  const [deleteRenewalScope, {
    isSuccess: isDeleteRenewalScopeFetching,
    data: deleteRenewalScopeData
  }] = useDeleteContractRenewalScopeMutation();

  const [addContractRenewalScope, {
    isSuccess: isContractRenewalScopeAdded,
    data: ContractRenewalScopeaddData,
  },] = useAddContractRenewalScopeMutation();

  const [extractCovered, {
    isLoading: isExtracting,
    isSuccess: isAllExtracted,
    data: extractAllData
  }] = useExtractCoveredMutation();

  useEffect(() => {
    if (!isAllContractRenewalScopesFetching && isAllContractRenewalScopesFetched && AllContractRenewalScopesData) {
      setContractRenewalScopes(AllContractRenewalScopesData);
    }
  }, [isAllContractRenewalScopesFetching, isAllContractRenewalScopesFetched, AllContractRenewalScopesData])

  useEffect(() => {
    if (!isAllContractRenewalAvailableScopesFetching && isAllContractRenewalAvailableScopesFetched && AllContractRenewalAvailableScopesData) {
      setContractRenewalAvailableScopes(AllContractRenewalAvailableScopesData)
    }
  }, [isAllContractRenewalAvailableScopesFetching, isAllContractRenewalAvailableScopesFetched, AllContractRenewalAvailableScopesData])

  useEffect(() => {
    if (isDeleteRenewalScopeFetching && deleteRenewalScopeData) {
      getAllContractRenewalScopes({ plContractKey: contractId });
      getAllContractRenewalAvailableScopes({ plContractKey: contractId });
    }
  }, [isDeleteRenewalScopeFetching, deleteRenewalScopeData]);

  useEffect(() => {
    if (isContractRenewalScopeAdded && ContractRenewalScopeaddData) {
      if (ContractRenewalScopeaddData) {
        ToastService.success(ContractRenewalScopeaddData?.errorMessage);
        getAllContractRenewalScopes({ plContractKey: contractId });
        getAllContractRenewalAvailableScopes({ plContractKey: contractId });
      }
    }
  }, [isContractRenewalScopeAdded, ContractRenewalScopeaddData]);

  useEffect(() => {
    if (contractId) {
      getAllContractRenewalScopes({ plContractKey: contractId });
      getAllContractRenewalAvailableScopes({ plContractKey: contractId })
    }
  }, [contractId]);

  useEffect(() => {
    if (!isExtracting && isAllExtracted && extractAllData) {
      const blob = new Blob([extractAllData]);
      saveAs(blob, `Extract Covered.xlsx`);
    }
  }, [isExtracting, isAllExtracted, extractAllData]);

  const gridRefresh = () => {
    getAllContractRenewalScopes({ plContractKey: contractId });
  }

  const handaleSave = async () => {
    if (!selectedCheckboxRows?.length) {
      ToastService.error("Please select at least one scope");
      return;
    }

    const request = {
      plContractKey: contractId,
      plScopeKeys: selectedCheckboxRows.map(x => x.lScopeKey)
    };

    const result = await addContractRenewalScope(request);

    if (result?.data) {
      getAllContractRenewalScopes({ plContractKey: contractId });
      getAllContractRenewalAvailableScopes({ plContractKey: contractId });
    }

    setSelectedCheckboxRows([]);
  };

  const handleExtractCovered = () => {
    const request = {
      plContractKey: contractId
    }
    extractCovered(request)
  }

  const handleIsModelOpen = () => {
    setIsModelOpen(true);
    // setIsScopeModelOpen(false);

    // setSelectedInvoice(null)
  };

  const handleIsCreateRenewalModelOpen = () => {
    setIsCreateRenewalModelOpen(true);
    // setIsScopeModelOpen(false);

    // setSelectedInvoice(null)
  };

  const handleIsContractModelOpen = () => {
    setIsContractModelOpen(true);
  };

  const handleIsNewScopeOpen = () => {
    setIsNewScopeModel(true);
  }
  const handleCloseModel = () => {
    setIsModelOpen(true);
    setIsContractModelOpen(false);
    // setIsScopeModelOpen(false);

    // setSelectedInvoice(null)
  };

  const getCtxMenuItemsCovered = (row) => {
    if (!row) return [];
    return [
      {
        label: "Edit",
        command: () => {
          setSelectedEditRow(row);
          setIsUpdateRenewalModelOpen(true);
        }
      },
      {
        label: "Remove",
        command: () => {
          confirm("",
            "Are you sure you want to remove this scope",
            "Yes",
            "No"
          ).then((confirmed) => {
            if (confirmed) {
              if (row) {
                deleteRenewalScope({
                  plContractKey: contractId,
                  plScopeKey: row.lScopeKey
                });
              }
            }
          });
        }
      }
    ];
  };

  const handleCloseImportModel = () => {
    setIsImportModelOpen(false);
  }

  const handleSuccessImport = () => {
    handleCloseImportModel();
  }

  const getCtxMenuItemsAvailable = (row) => {
    if (!row) return [];
    return [
      {
        label: "Copy",
        command: () => { }
      }
    ];
  };

  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Extract Coverd"
          onClick={handleExtractCovered}
          buttonTypeClassName="btn blue-btn"
          titleText="Extract Coverd"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="Import Coverd"
          onClick={() => setIsImportModelOpen(true)}
          buttonTypeClassName="btn blue-btn"
          titleText="Import Coverd Scopes"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="Inialize Renewal"
          // onClick={handleUnassignClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Inialize Renewal"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="Create Renewal Doc"
          onClick={handleIsCreateRenewalModelOpen}
          buttonTypeClassName="btn blue-btn"
          titleText="Create Renewal Document"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="Renewal Contract"
          onClick={handleIsContractModelOpen}
          buttonTypeClassName="btn blue-btn"
          titleText="Renewal Contract"
        // isLoading={isDeleting}
        />
      </div>
    );
  };
  const availableScopesContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Scope"
          onClick={handaleSave}
          buttonTypeClassName="btn blue-btn"
          titleText="Add Selected Scope"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="New Scope"
          onClick={handleIsNewScopeOpen}
          buttonTypeClassName="btn blue-btn"
          titleText="Add New Scope"
        // isLoading={isDeleting}
        />
      </div>
    );
  };

  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle={`Covered Scopes`}
            customHeader={true}
            headerContent={headerContent()}
          >
            <MolGrid
              value={contractRenewalScopes}
              expandableRowGroups={true}
              paginator={false}
              rows={99999}
              rowsPerPageOptions={[10, 25, 50, 100]}
              // virtualScrollerOptions={{ itemSize: 18 }}
              paginatorTemplate={{
                layout:
                  "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                RowsPerPageDropdown: (options) => {
                  // return customRowsPerPageDropdown(options, options?.value);
                },
              }}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItemsCovered}
            >
              <Column
                field="lScopeKey"
                header="Serial#"
                grouping
                sortable
              />
              <Column
                field="sScopeTypeDesc"
                header="Model"
                grouping
                sortable
              />
              <Column field="sClientName1" header="Client" grouping sortable />
              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
              />
              <Column field="nCost" header="Cost" grouping sortable />
            </MolGrid>
          </CardSection>
        </div>
        <div className="scrollable-grid col-12 available-department">
          <CardSection
            cardTitle={`Available Scopes`}
            customHeader={true}
            headerContent={availableScopesContent()}
          >
            <div className="scrollable-grid col-12">
              <MolGrid
                value={contractRenewalAvailableScopes}
                expandableRowGroups={true}
                paginator={false}
                rows={99999}
                rowsPerPageOptions={[10, 25, 50, 100]}
                // virtualScrollerOptions={{ itemSize: 18 }}
                paginatorTemplate={{
                  layout:
                    "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                  RowsPerPageDropdown: (options) => {
                    // return customRowsPerPageDropdown(options, options?.value);
                  },
                }}
                scrollable
                scrollHeight="flex"
                filterDisplay="row"
                sortMode="single"
                showGridlines
                resizableColumns
                ctxMenuItems={getCtxMenuItemsAvailable}
                selection={selectedCheckboxRows}
                onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
                dataKey="lScopeKey"
              >
                <Column selectionMode="multiple" bodyStyle={{ textAlign: "center" }} />
                <Column
                  field="lScopeKey"
                  header="Serial#"
                  grouping
                  sortable
                />
                <Column
                  field="sScopeTypeDesc"
                  header="Model"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Client"
                  grouping
                  sortable
                />
                <Column
                  field="sDepartmentName"
                  header="Department"
                  grouping
                  sortable
                  style={{ width: '25%' }}
                />
              </MolGrid>
            </div>
          </CardSection>
        </div>
        <CustomCenterModel
          isOpen={isNewScopeModel}
          useCustomBg={true}
          modalTitle={"New Scope"}
          contentClass="content-40"
          onClose={() => setIsNewScopeModel(false)}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <AddRenewal onClose={() => setIsNewScopeModel(false)} contractId={contractId} gridRefresh={gridRefresh} />
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isContractModelOpen}
          useCustomBg={true}
          modalTitle={"New Contract"}
          contentClass="content-40"
          onClose={() => setIsContractModelOpen(false)}
          modalTitleIcon={AppIcons.AddIcon}
          className="renewal-contract-model"
        >
          <NewContract onClose={() => setIsContractModelOpen(false)} row={contractData} />
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isCreateRenewalModelOpen}
          useCustomBg={true}
          modalTitle={"Create Renewal Document"}
          contentClass="content-40"
          onClose={() => setIsCreateRenewalModelOpen(false)}
          modalTitleIcon={AppIcons.AddIcon}
          className="renewal-contract-model"
        >
          <CreateRenewal onClose={() => setIsCreateRenewalModelOpen(false)} />
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isUpdateRenewalModelOpen}
          useCustomBg={true}
          modalTitle={"Update Scope Cost"}
          contentClass="content-40"
          onClose={() => setIsUpdateRenewalModelOpen(false)}
          modalTitleIcon={AppIcons.editIcon}
        >
          <UpdateRenewal row={selectedEditRow} onClose={() => setIsUpdateRenewalModelOpen(false)} gridRefresh={gridRefresh} />
        </CustomCenterModel>

        <CustomCenterModel
          isOpen={isImportModelOpen}
          useCustomBg={true}
          modalTitle={"Import Contract Renewal"}
          contentClass="content-40"
          onClose={handleCloseImportModel}
          modalTitleIcon={AppIcons.editIcon}
        >
          <ImportContractRenewal
            contractId={contractId}
            isOpen={isImportModelOpen}
            onClose={handleCloseImportModel}
            onSuccess={handleSuccessImport}
            gridRefresh={gridRefresh}
          />
        </CustomCenterModel>

      </div>
    </>
  );
};
export default Renewal;
